module.exports = __webpack_public_path__ + "img/sloth-on-vacations.75ce49f8.svg";